// ThemeContext.js
import React, { createContext, useContext } from 'react';
import { sizes, themeStyles } from './themes';

// Create the context
const ThemeContext = createContext();

// Theme provider component
export const ThemeProvider = ({ children, themeKey = 'uplynk', size = 'medium' }) => {
  // console.log('size: ', size);
  // Get the theme and size objects, with fallbacks
  const sizeObj = sizes[size] || sizes.medium;
  const themeObj = themeStyles[themeKey] || themeStyles.uplynk;
  
  // Combine styles directly
  const theme = {
    container: `${sizeObj.container} ${themeObj.container}`,
    header: `${sizeObj.header} ${themeObj.header}`,
    body: `${sizeObj.body} ${themeObj.body}`,
    description: `${sizeObj.description} ${themeObj.description}`,
    fieldCombo: `${sizeObj.fieldCombo}`,
    label: `${sizeObj.label} ${themeObj.label}`,
    input: `${sizeObj.input} ${themeObj.input}`,
    chckbxLabel: `${sizeObj.chckbxLabel} ${themeObj.chckbxLabel}`,
    checkbox: `${sizeObj.checkbox} ${themeObj.checkbox}`,
    info: `${sizeObj.info} ${themeObj.info}`,
    readyButton: `${sizeObj.readyButton} ${themeObj.readyButton}`,
    button: {
      primary: `${sizeObj.button.primary} ${themeObj.button.primary}`,
      secondary: `${sizeObj.button.secondary} ${themeObj.button.secondary}`,
    },
    result: {
      container: `${sizeObj.result.container} ${themeObj.result.container}`,
      title: `${sizeObj.result.title} ${themeObj.result.title}`,
      content: `${sizeObj.result.content} ${themeObj.result.content}`

    },
    infoBox: {
      container: `${sizeObj.infoBox.container} ${themeObj.infoBox.container}`,
      title: `${sizeObj.infoBox.title} ${themeObj.infoBox.title}`,
      content: `${sizeObj.infoBox.content} ${themeObj.infoBox.content}`
    }
  };
  

  return (
    <ThemeContext.Provider value={{ theme, themeKey, size }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};